import CartRow from "./CartRow.jsx";
import CartBuild from "./CartBuild.jsx";

/**
 * Fold the flat Store API item list into render groups: a racket build (racket
 * line + its extras, keyed by item.extensions.sa_build.id) renders as one
 * CartBuild; everything else is a plain CartRow. Insertion order is kept.
 */
function toGroups(items) {
	const groups = [];
	const byBuild = new Map();

	for (const item of items) {
		const build = item.extensions?.sa_build;
		if (build?.id) {
			let g = byBuild.get(build.id);
			if (!g) {
				g = { type: "build", buildId: build.id, racket: null, extras: [] };
				byBuild.set(build.id, g);
				groups.push(g);
			}
			if (build.role === "racket") g.racket = item;
			else g.extras.push(item);
		} else {
			groups.push({ type: "single", item });
		}
	}
	return groups;
}

export default function CartItems({
	items,
	busyKeys,
	loading,
	onUpdateQty,
	onRemove,
	onRemoveBuild,
	onClearCart,
}) {
	const groups = toGroups(items);

	return (
		<div className={`zc-items${loading ? " is-loading" : ""}`}>
			<div className="zc-items__header">
				<button className="zc-items__clear" onClick={onClearCart} type="button">
					Clear cart
				</button>
			</div>

			<div className="zc-items__list">
				{groups.map((group) =>
					group.type === "build" ? (
						<CartBuild
							key={group.buildId}
							group={group}
							busy={[group.racket, ...group.extras].some(
								(it) => it && busyKeys.has(it.key),
							)}
							onRemoveBuild={onRemoveBuild}
						/>
					) : (
						<CartRow
							key={group.item.key}
							item={group.item}
							busy={busyKeys.has(group.item.key)}
							onUpdateQty={onUpdateQty}
							onRemove={onRemove}
						/>
					),
				)}
			</div>
		</div>
	);
}
